<template>
  <div style="height:100%;display:inline-block;width:100%;">
        <div style="height:100%;display:inline-block;width:100%;">
              <div class="height-set">
                <div style="height:100%;">
                    <div class="w-100 h-100">
                          <div style="display: inline-block;padding:14px;width: 100%;height: calc(100% - 55px);">
                            <div>
                              <nav class="navbar navbar-expand-lg p-0" style="width:50%;display:inline-block;float:inline-start;">
                                <div class="collapse navbar-collapse">
                                    <div class="navbar-nav w-100 top-nav-bar">
                                        <!-- <a class="nav-item nav-link" style="width:16%;font-size: 24px !important"
                                          v-on:click="tabType = 'AWS';handleTabSwitch('AWS')" :class='{active: tabType === "AWS"}'>AWS
                                        </a>
                                        <a class="nav-item nav-link" style="width:16%;font-size: 24px !important"
                                          v-on:click="tabType = 'Vision';handleTabSwitch('vision')" :class='{active: tabType === "Vision"}'>Vision
                                        </a> -->
                                        <a class="nav-item nav-link" style="width: 16%; font-size: 24px !important;text-align: start;color: #eee !important;"
                                          v-on:click="tabType = 'Personalities';handleTabSwitch('personalities')" :class='{active: tabType === "personalities"}'>{{$t('Personalities')}}
                                        </a>
                                    </div>
                                </div>
                              </nav>
                              <div class="edit-icon-visibility search-bar-comm-style comm-div" style="width:50%;display:inline-block;float:inline-end;">
                                <input
                                  type="text"
                                  v-model="personalityName"
                                  class="bg-transparent rounded text-light w-100"
                                  :placeholder="$t('Search by Personality name')"
                                  @keyup.enter="searchPersonalityName"
                                />
                                <svg
                                  width="1em"
                                  height="1em"
                                  viewBox="0 0 16 16"
                                  class="bi bi-search"
                                  fill="#c5c0c0"
                                  xmlns="http://www.w3.org/2000/svg"
                                  @click="searchPersonalityName"
                                >
                                  <path fill-rule="evenodd" d="M10.442 10.442a1 1 0 0 1 1.415 0l3.85 3.85a1 1 0 0 1-1.414 1.415l-3.85-3.85a1 1 0 0 1 0-1.415z"/>
                                  <path fill-rule="evenodd" d="M6.5 12a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11zM13 6.5a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0z"/>
                                </svg>
                              </div>
                            </div>  
                              <template v-if="tabType=='Personalities'">
                                <div class="personalities-main-wrappers" style="height: calc(100% - 45px);display: inline-block;overflow: auto;width: 100%;">
                                  <div style="overflow:auto;height:100%" class="w-100">
                                    <div style="flex-wrap: wrap;justify-content: start;display: inline-flex;padding:14px;float:inline-start">
                                      <div style="margin: 5px 19px 0px 19px;" v-on:click="createProfile = true">
                                        <div class="add-user-icon-wrapper">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" class="bi bi-person-plus-fill" viewBox="0 0 16 16">
                                            <path d="M1 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                                            <path fill-rule="evenodd" d="M13.5 5a.5.5 0 0 1 .5.5V7h1.5a.5.5 0 0 1 0 1H14v1.5a.5.5 0 0 1-1 0V8h-1.5a.5.5 0 0 1 0-1H13V5.5a.5.5 0 0 1 .5-.5z"/>
                                          </svg>
                                        </div>
                                        <div style="position:relative;top:1px;">{{$t('Add Profile')}}</div>
                                      </div>
                                        <template>
                                          
                                          <div  v-for="personality in personalitiesData"  :key="personality._id" class="comm-tags-class" style="width:100px;padding: 5px;margin-bottom: 8px;position:relative">
                                            <div @click="selectedProfile=personality, openPersonalityData(personality._id)" :title="personality.display_name" >
                                              <div v-if="Object.keys(personality).includes('profile_image') && personality.profile_image" class='user-name-or-image'>
                                                  <img :src="getProxyConvertedURL(personality.profile_image)" @error="replaceWithUserIcon($event,personality.name)" style="width:100%;height:100%;border-radius:6px;margin-bottom: 5px">
                                                  <template v-if="'job_state' in personality && ['QUEUED','IN_PROGRESS'].includes(personality.job_state)">
                                                  <div v-if="personality.job_state" :key="personality.progress" class="progress">
                                                      <div v-if="personality.progress" :key="personality.progress" :style="{width:personality.progress + '%',background:personality.remove_personality?'#b32828':''}" class="progress-bar" role="progressbar" :aria-valuenow="personality.progress" aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                  </template>
                                             </div>
                                              <div v-else class="user-name-or-image" :style="style(personality.name)" >{{personality.name.split("")[0]}}
                                                <template v-if="'job_state' in personality && ['QUEUED','IN_PROGRESS'].includes(personality.job_state)">
                                                  <div v-if="personality.job_state" :key="personality.progress" class="progress">
                                                    <div v-if="personality.progress" :key="personality.progress" :style="{width:personality.progress + '%',background:personality.remove_personality?'#b32828':''}" class="progress-bar" role="progressbar" :aria-valuenow="personality.progress" aria-valuemin="0" aria-valuemax="100"></div>
                                                  </div>
                                                </template>
                                              </div>
                                              <div style="text-align:center;word-break: break-word;" >{{personality.name}}</div>
                                            </div>
                                            <div class="hover-action">
                                              <EditIcon class="edit-user-icon" @click.native="editProfile(personality)"></EditIcon>
                                              <!-- <CancelIcon class="delete-user-icon" @click.native="deleteProfile(personality._id, personality.name)"></CancelIcon> -->
                                              <svg  @click="deleteProfile(personality)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#939393" class="bi bi-trash edit-user-icon" viewBox="0 0 16 16" style="fill: #bababa;position: absolute;inset-inline-end :2px;top: 3px;">
                                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5Zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6Z"/>
                                                <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1ZM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118ZM2.5 3h11V2h-11v1Z"/>
                                              </svg>
                                            </div>
                                          </div>
                                        </template>
                                    </div>   
                                  </div>
                                </div>
                              </template>

                          </div> 
                          <div>
                            <pagination
                                v-if="totalPersonalities > -1"
                                v-model="page"
                                :records="totalPersonalities"
                                :per-page="PersonalitiesPerPage"
                                @paginate="paginate"
                                :options="options"
                                style="margin-top:10px"
                            />    
                        </div>  
                    </div>
                </div>
              </div>
        </div>
        <CustomAlertMessage v-if="enableCustomMessage" v-bind="currentProperties" @close="enableCustomMessage = false" @allowDeletion="allowToDeleteProfile()"></CustomAlertMessage>
        <CreateOrEditProfile v-if="createProfile" :newProfile="isNewProfile" :profileInfo="selectedProfile" @close="closeCreateProfileComp();"></CreateOrEditProfile>
</div>
</template>

<script>

import {mapActions,mapMutations} from "vuex"
// import Constants from "../../components.constants.js";
import Utils from "../../components.utils.js";
import Pagination from "vue-pagination-2";
import CreateOrEditProfile from "./createOrEditProfile.vue";
import { NotifierConstants } from "../../components.constants";
// import CancelIcon from "../core/InlineCancelField.vue";
import EditIcon from "../core/InlineEditField.vue";
// import individualPersonality from "./individualPersonality.vue"
import CustomAlertMessage  from "../actions/customAlertMessage.vue";

export default {
  data(){
      return {
        selectedPersonality:{},
        enableCustomMessage:false,
        isNewProfile:true,
        selectedProfile:{},
        createProfile: false,
        tabType:"Personalities",
        editKey:null,
        // faceDetectionConfigData:[],
        // faceDetectionCloudDetails : {},
        // faceDetectionVisionDetails : {},

        options:{chunk:5},
        page: 1,
        totalPages: -1,
        totalPersonalities: -1,
        PersonalitiesPerPage: -1,
        personalitiesData:[],
        passwordFieldType:"password",
        indPersonalityData:{},
        showIndPersonality:false,
        personalityName:"",
        jobIdMapper:{}
      }
  },
  computed: {
    currentProperties() {
      return {"messageTitle":"Delete",
                "messageType": "",
                "displayMessage":`Are you sure you want to delete selected ' ${this.selectedPersonality.name} ' personality ?`,
                "getUserConfirmation":true}
    },
    getPersonalitiesDataArr(){
      return this.personalitiesData;
    },
    getKey(personality){
      if(personality.status_info){
        return personality._id + personality.status_info.progress;
      }else{
        return personality._id;
      }
    },
  },
  components:{
    CreateOrEditProfile,
    pagination: Pagination,
    // CancelIcon,
    EditIcon,
    CustomAlertMessage,
    // "personality" :individualPersonality,  
  },
  methods:{
    closeCreateProfileComp(){
      this.createProfile = false;
      this.isNewProfile=true;
      this.selectedProfile = {};
    },
    style(name){
        let style = {
            'color':Utils.textColor(Utils.intToRGB(Utils.hashCode(name))),
            'background-color':'#'+Utils.intToRGB(Utils.hashCode(name))
        }
      return style
    },
    
    handleTabSwitch(type){
      console.log("handleTabSwitch");
      this.editKey = null;
      if(type == 'personalities'){
        this.getPersonalitiesdata();
      }
    },

    editKeyOnDoubleClick(keyName){
      this.editKey = keyName;
    },

    enterIntoEditMode(keyName){
      this.editKey = keyName;
    },

    isEditing(keyName) {
      return keyName === this.editKey;
    },

    getPersonalitiesdata(params){
      let payload = {};
      if(params){
        payload.params = params;
      }
      this.getPersoanlitiesDataFromServer(payload).then((data)=>{
        this.personalitiesData = data["personalities"];
        this.totalPersonalities = data["total_personalities"];
        this.totalPages = data["page_count"];
        this.PersonalitiesPerPage = data["personalities_per_page"];
        // this.totalPersonalities = 70;
        // this.totalPages = 3;
        // this.PersonalitiesPerPage = 25;
        this.page = data["page"];

      });
    }, 
     
    // replaceWithUserIcon(e){
    //     e.target.onerror = null
    //     e.target.src = Constants.noImage;
    // },

    replaceWithUserIcon(e){
        e.target.onerror = null
        e.target.src = Utils.getNoThumbnailImg();
    },

    paginate(page) {
        this.page = page;
        this.totalPages = -1
        this.totalPersonalities = -1
        this.PersonalitiesPerPage = -1;

        let payloadParam = {};
        payloadParam["page"] = this.page;
        if(this.personalityName){
          payloadParam["name"] = this.personalityName;
        }  
        this.getPersonalitiesdata(payloadParam);
        // let query = Object.assign({},this.$route.query)
        // query.page = this.page
        // this.$router.push({
        //     query: query
        // })
    },

    editProfile(profileInfo){
      this.selectedProfile = profileInfo;
      this.isNewProfile = false;
      this.createProfile = true;
    },

    searchPersonalityName(){
      let payloadParam={};
      payloadParam["name"] = this.personalityName;
      this.getPersonalitiesdata(payloadParam);
    },  

    deleteProfile(personality){
      this.selectedPersonality = personality
      this.enableCustomMessage = true
    },
    allowToDeleteProfile(){
      this.enableCustomMessage = false
      this.submitJobPost(this.selectedPersonality._id);
    },

    submitJobPost(personalityID){
      let payload = {
          "personality_id": personalityID,
          "job_name": "Personality Update",
          "element_type": "file",
          "remove_personality": true  // Serve it only on perosnality deletion
      };
      
      this.createNewJob(payload).then((data) => {
        if (data.statusCode == 200) {
          this.$toast.success(data.message);
        } else {
          this.$toast.error(data.message);
        }
      })
    },

    openPersonalityData(personalityId){
      this.$emit("changeSelectedComponent","individual-personality", personalityId);   
    },

    handleBulkMetadataNotification(notification){
      notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
            let mssgInfo = notification.message;
            let progress = 0
            if(mssgInfo.status_info && mssgInfo.status_info.progress){
              progress = mssgInfo.status_info.progress
            }
            
            if(mssgInfo.state == 'QUEUED'){
              let indx = this.personalitiesData.findIndex(op=>op._id == mssgInfo.data.personality_id)
              if(indx >= 0 && mssgInfo.state == 'QUEUED'){
                this.$set(this.personalitiesData[indx], 'job_state', mssgInfo.state)
                this.$set(this.personalitiesData[indx], 'progress', progress)
              }
            }else{
              let indx = this.personalitiesData.findIndex(op=>op._id == mssgInfo.personality_id)
              if (indx >= 0 && (this.personalitiesData[indx].state != mssgInfo.state || this.personalitiesData[indx].progress != progress)){
                this.$set(this.personalitiesData[indx], 'job_state', mssgInfo.state)
                this.$set(this.personalitiesData[indx], 'progress', progress)
                this.$set(this.personalitiesData[indx], 'remove_personality', mssgInfo.remove_personality)
                if(mssgInfo.remove_personality && mssgInfo.state && mssgInfo.state == 'COMPLETED'){
                  this.removePersonality({params:{_id:mssgInfo.personality_id}}).then(data=>{
                    console.log("[Removed personality]",data)
                    this.selectedPersonality = {}
                  });
                  this.$toast.success(mssgInfo.resource_name + ' deleted successfully');
                }else if(mssgInfo.state && mssgInfo.state == 'COMPLETED'){
                  this.$toast.success(mssgInfo.resource_name + ' updated successfully');
                }
              }
            }
        }
    },

    handleScriptUpdateNotification(notification){
        notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
        if(notification.message){
              let person_info = notification.message
                if([NotifierConstants.personalityCreateNotification].includes(notification.message_type)){
                    let newProfle = {name:person_info.name, profile_image:person_info.profile_image,_id:person_info._id}
                    if('alias' in person_info){
                      newProfle['alias'] = person_info.alias;
                    }
                    this.personalitiesData.push(newProfle)
                }else if([NotifierConstants.personalityUpdateNotification].includes(notification.message_type)){
                    let indx = this.personalitiesData.findIndex(op=>op._id == person_info._id)
                    if(indx >= 0){
                      if('name' in person_info){
                        this.$set(this.personalitiesData[indx],"name",person_info.name);
                      }
                      if('alias' in person_info){
                        this.$set(this.personalitiesData[indx],"alias",person_info.alias);
                      }
                      if('nationality' in person_info){
                        this.$set(this.personalitiesData[indx],"nationality",person_info.nationality);
                      }
                      if('state' in person_info){
                        this.$set(this.personalitiesData[indx],"state",person_info.state);
                      }
                      if('profession' in person_info){
                        this.$set(this.personalitiesData[indx],"profession",person_info.profession);
                      }
                      if('description' in person_info){
                        this.$set(this.personalitiesData[indx],"description",person_info.description);
                      }
                      if(person_info.profile_image && person_info.profile_image.trim().length > 0){
                        this.$set(this.personalitiesData[indx],"profile_image",person_info.profile_image)
                      }
                    }
                }else if([NotifierConstants.personalityDeleteNotification].includes(notification.message_type)){
                  this.personalitiesData = this.personalitiesData.filter(op=>op._id != person_info._id)
                }
        }
    },
    registerforWebsocketNotifications(){
      this.addWSEventListener({eventname:[NotifierConstants.personalityCreateNotification,NotifierConstants.personalityUpdateNotification,NotifierConstants.personalityDeleteNotification],callback:this.handleScriptUpdateNotification,parent: "faceDetectionPersonalitiesMain"})
      this.addWSEventListener({eventname:["JOB_STATUS_UPDATE"],callback:this.handleBulkMetadataNotification,parent: "faceDetectionPersonalitiesMain"})
    },
    UnregisterfromWebsocketNotifications(){
      this.removeWSEventListener({ eventname:[NotifierConstants.personalityCreateNotification,NotifierConstants.personalityUpdateNotification, NotifierConstants.personalityDeleteNotification],callback:this.handleScriptUpdateNotification,parent: "faceDetectionPersonalitiesMain"})
      this.removeWSEventListener({eventname:["JOB_STATUS_UPDATE"],callback:this.handleBulkMetadataNotification,parent: "faceDetectionPersonalitiesMain"})
    },
    ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
    ...mapActions("AIDataSet", ["getPersoanlitiesDataFromServer","removePersonality"]),
    ...mapActions("jobs", ["createNewJob"]),
  },

  created(){
      // this.getfaceDetectionConfigData();
      this.getPersonalitiesdata();
      this.registerforWebsocketNotifications();
  },
  beforeDestroy(){
    this.UnregisterfromWebsocketNotifications()
  }
}

</script>



<style scoped lang="scss">
  $table-row-border: none;
  $active-blue: #007bff;
  $danger-color: #dc3545;
  $none-text-color:#4f4f4f;
  $add-button-text-color:#0b7099;
  $add-button-text-color-hover:#0193cc;
  $add-button-border-color:#b7b228;
  $add-button-border-on-hover:#dcd426;
  $add-button-backgroud:#1e1e1e;
  $active-green-color:#28a745;
  $border-color: 1px solid #4a4a4a;
  $primary-background: #1a1e21;
  $secondary-background-color:#15181B;
  $bg-color-on-hover: #22272b;
  $text-color: #eee;
  $dull-text-color: #757575;
  $secondary-text-color: #9c9c9c;
  $active-blue : #007bff;
  $input-field-and-label-font-size:14px;
  $input-field-height:38px;
  $highlight-font-color:#ff9800;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555; 
  $input-field-padding:.375rem 10px;
  $filter-border-color: #5a5a5a;
  $filter-bg-color: #2a2a2a;
  $learn-about-text-color-hover:#b7b327;
  $learn-about-text-color:#9a9620;
  $tags-background-color:#282d31;
  $svg-color:#666;
  $tags-border-color:#363636;
  $secondary-border-color: 1px solid #2b2b2b;
  $input-field-bg-color: #121212;
  $input-field-border-color: #202020;
  $input-field-height:38px;
  $scrollbar-thumb-background:#333;
  $scrollbar-track-background:#1a1e21;
  $scrollbar-thumb-on-hover-background:#555;

.modal-dialog {
    max-width: calc(100% - 100px);
    width: calc(100% - 100px);
    height: inherit;
    margin: 0;
    padding: 0;
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    .modal-body{
      background: $primary-background;
      height: 500px;
      overflow: auto;
      user-select: text !important; 
    }
  }

  .modal {
      text-align: center;
      padding: 0 !important;
      display: block;
      position: fixed;
      inset-inline-start: 0px;
      top: 0px;
  }
  .modal:before {
    content: '';
      display: inline-block;
      height: 100vh;
      vertical-align: middle;
      margin-inline-end: -4px;
      position: fixed;
      width: 100vw;
      inset-inline-start: 0;
      top: 0;
      background: #00000094;
  }
  .modal-dialog {
    display: inline-block;
    text-align: start;
    vertical-align: middle;
  }

  .modal-header,.modal-footer{
      border-top: $secondary-border-color !important;
      border-bottom: $secondary-border-color !important;
      background: $secondary-background-color;
      .modal-title{
        color:$text-color;
        padding: 1%;
      }
  }

  .modal-header .close {
      margin: -1rem -13px -1rem auto !important;
  }

  .height-set{
    // height: calc(100vh - 52px);
    height: 100%;
    background: #1a1e21 !important;
    .group-name{
      text-align: start;
      padding:16px 3%;
      font-size:27px;
      display:flex;
    }
    .group-members{
      height: calc(100% - 90px);
      cursor: pointer;
    }
  }

  .add-user-icon-wrapper{
      // height: 59px;
      // width: 60px;
      // line-height: 54px;
      // border-radius: 6px;
      // background: $primary-background;
      // color: $add-button-text-color;
      // border: 1px solid $add-button-border-color; 
        display:inline-block;
        border: 1px solid $add-button-border-color; 
        display:inline-block;
        height: 60px;
        width: 60px;
        border-radius: 10px;
        text-align: center;
        line-height: 56px;
        text-transform: uppercase;
        margin: 0 auto;
        font-size: 30px;
        top:-3px;
        position: relative;
      svg{
        margin:auto;
      }
  }

  .add-user-icon-wrapper:hover{
      color: $add-button-text-color-hover;
      border: 1px solid $add-button-border-on-hover; 
  }

  .editIcon {
      margin-inline-start: 9px;
      margin-top: 0px
  }

  .comm-input-field-style{
      background: $primary-background!important;
      height:40px;
      width: 100%;
      float: inline-start;
      padding-inline-start: 12px;
      padding-bottom: 2px;
      border: $border-color!important;
  }

  #contact_number_input::-webkit-outer-spin-button,
  #contact_number_input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .close-icon:hover{
    background: #373737;
    border-radius: 20px;
  }
  .users-basic-info-table {
    tbody {
      margin: 10px;
      .key-div {
        text-align: start;
        color: $dull-text-color;
        padding-inline-start: 3% !important;
        line-height: 36px;
      }
      .value-div {
        text-align: start;
        margin-inline-start: 10px;
        width: 30%;
        font-weight: 500;
        input,select{
          padding-inline-start:4px;
        }
      }
    }
  }

  .activeclass {
    color: $active-blue;
  }

  table {
    background: transparent;
    thead {
      th {
        color: $dull-text-color;
        border-top: none !important;
        border-bottom: none !important;
      }
    }
    tbody {
      color: $text-color;
      td {
        border-top: none !important;
      }
    }
  }

  .btn {
    font-size: $input-field-and-label-font-size !important;
    height: 100%;
  }

  .custom-control-label::before {
    background-color: $primary-background;
  }

  table.users-basic-info-table .editIcon {
    visibility: hidden;
  }
  table.users-basic-info-table td.value-div:hover .editIcon {
    visibility: visible;
  }

  .disablefield {
    border: none !important;
    pointer-events: none;
  }

  .force-logout {
    position: relative;
    inset-inline-start: 5px;
    bottom: 4px;
  }
  .force-logout:hover {
    text-decoration: underline;
  }
  .activestatus {
    color: $active-green-color !important;
  }
  .validationmessage {
    color: $danger-color;
    font-size: 11px;
  }

  .nav-item{
      color: $dull-text-color !important;
  }

  .active{
      //background: $primary-background !important;
      color: $text-color !important;
  }
  // .top-nav-bar{
  //     //background: $primary-background;
  // }

  .tags-display-ul .show-tags-delete{
    visibility:hidden;
  }

  .tags-display-ul li:hover .show-tags-delete{
    visibility: visible;
  }

  .editIcon{
    visibility:hidden;
  }

  .group-name:hover .editIcon{
    visibility: visible;
  }

  .show-tags-delete{
    position: relative;
    top: 2px;
  }

  .view-tags{
    font-size: 12px;
    height: 24px;
    display: inline-flex;
    margin:2px !important;
    border: $border-color!important;
    border-radius: 15px !important;
    min-width: 50px;
    padding: 0px !important;
    text-align: center;
    width:auto !important;
    div{
            padding: 0px 8px;
            margin-inline-start: 0px;
            font-size: 12px;
            border-radius: 15px !important;
            position: relative;
            top: 1px;
    }
  }
  

  .breadcrumb{
    padding: .75rem 1rem !important;
    //background: $primary-background !important;
      .active-text-nav-bar{
          color: $text-color !important;
          text-decoration: none !important
      }
      .active-text-nav-bar:last-child{
              color: $active-blue !important;
              font-size:17px;
      }
      .breadcrumb-item{
          a{
              color: $text-color;
              font-weight:600;
          }
          a:hover{
              text-decoration: underline;
          }
      }    
  }
  .user-name-or-image{
      height: 60px;
      width: 60px;
      border: $border-color;
      border-radius: 10px;
      text-align: center;
      line-height: 56px;
      text-transform: uppercase;
      margin: 0 auto;
      font-size: 30px;
      position: relative;
  }

  .progress{
    position: absolute;
    bottom: 0.5px;
    width: 100%;
    height: 7px;
    background-color: #e9ecef40;
  }

  .hover-action{
    visibility: hidden;
  }

  .comm-tags-class:hover .hover-action{
    visibility: visible;
  }

  .hover-action{
    position: absolute;
    inset-inline-end: 11px;
    top: 1px;
    height: 23px;
    display: inline-flex;
    width: 45px;
    padding-inline-start: 6px;
    border: $border-color;
    background: $secondary-background-color;
    border-radius: 4px;
    color: $text-color;
  }

  .primary-btn-style {
    margin-top: 1%;
    bottom: 8px;
    inset-inline-end: 0%;
    height:50px;
    width:100%;
    z-index:9;
    button {
      height: 38px !important;
      width: 70px;
      font-size:14px;
      margin-top:7px;
    }
    .btn-outline-secondary{
      float:inline-end;
    }
    .btn-outline-primary{
      margin-inline-end:15px;
    }
  }

  .edit-user-icon:hover{
    fill:#eee !important;
  }

  .nav-item{
      //background: $primary-background !important;
      color: $dull-text-color !important;
  }

  .active{
      color:$text-color !important;
  }
  .plugin-config-ul {
      list-style-type: none;
      display: inline-block;
      width: 100%;
      overflow:auto;
      padding-top: 10px;
      // height: calc(100vh - 350px);
      overflow: auto;
      height: calc((100% - 45px) - 70px);
  }
  
  .plugin-config-ul li {
      width: 100%;
      display: inline-flex;
      margin-bottom: 20px;
  }
  
  .plugin-config-ul li .config-label {
      width: 10%;
      text-align: end;
      color: #757575;
      word-break: break-word;
      position: relative;
      top: 9px;
  }
  .plugin-config-ul li .config-value {
      margin-inline-start: 14px;
      width: 24%;
      display:grid;
      svg{
          position: relative;
          top: 9px;
          margin-inline-start: 10px;
      }
  }
  
  .plugin-config-ul li .config-value input,select {
      width: 100%;
      // height: 27px;
      color: #eee !important;
      padding-inline-start: 2px;
      background: transparent;
      border: 1px solid #3a3a3a !important;
      border-radius: 4px;
  }
  
  .plugin-config-ul li .config-value .config-details {
      font-size: 14px;
      // color: #757575;
      text-align: start;
      padding-inline-start: 11px !important;
      color:$dull-text-color;
  }

  .key-div {
      text-align: end;
      color: $dull-text-color;
      position: relative;
      top: 9px;
      margin-inline-end: 20px;
      width:10%;
  }
  .value-div {
      text-align: start;
      margin-inline-start: 10px;
      display:block;
      span{
          padding-inline-start:7px !important;
          // position: relative;
          // top: 9px;
          color:$dull-text-color;
      }
      svg{
          position: relative;
          top: 9px;
          margin-inline-start:10px;
      }
  }
  .edit-icon{
      visibility: hidden;
  }
  .edit-icon-visibility{
      width: 100%;
  }

  .edit-icon-visibility:hover{
      .edit-icon{
          visibility: visible;
      } 
  }
  .comm-input-field-style{
      background: $input-field-bg-color;
      // width: 100% !important;
      float: inline-start;
      padding: $input-field-padding;
      border: 1px solid $input-field-border-color;
      font-size:$input-field-and-label-font-size;
      height: $input-field-height;
  }

  .commDefaultInputFields{
      border: none !important;
      background: transparent !important;
      cursor: pointer;
      pointer-events: auto;
      outline: none;
  }
  .add-user-icon-wrapper{
    height: 59px;
    width: 60px;
    line-height: 54px;
    border-radius: 6px;
    background: $primary-background;
    color: $add-button-text-color;
    border: 1px solid $add-button-border-color; 
  }

  .add-user-icon-wrapper:hover{
      color: $add-button-text-color-hover;
      border: 1px solid $add-button-border-on-hover; 
  }

  .search-bar-comm-style {
    height: 30px;
    position: relative;
    input {
      background: #1a1e21 !important;
      height: 40px;
      width: 250px !important;
      float: inline-end;
      margin-inline-end: 3%;
      padding-inline-start: 12px;
      padding-bottom: 2px;
      border: 1px solid #4a4a4a !important;
    }
    svg {
      position: absolute;
      inset-inline-end: 34px;
      top: 14px;
    }
  }

  /* width */
  ::-webkit-scrollbar {
    width: 8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: $scrollbar-track-background;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $scrollbar-thumb-background;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $scrollbar-thumb-on-hover-background;
  }

  ::v-deep {
    .page-item.disabled .page-link {
        background-color: $secondary-background-color !important;
        border: $border-color !important;
        // border: none;
    }
    .page-item.active .page-link {
        background-color: $secondary-background-color !important;
        // border: none !important;
        border: $border-color !important;
        color: $active-blue;
        z-index: 0 !important;
    }
    .page-link {
        background-color: $secondary-background-color !important;
        border: $border-color !important;
        // border: none !important;
        color: $text-color;
        padding: 5px !important;
    }
    .page-link:hover {
        background-color: $bg-color-on-hover !important;
    }
    .pagination {
        float: inline-end;
        margin-bottom: 0px !important;
        margin-inline-end: 8px;
    }
    .VuePagination__count {
        color: $secondary-text-color !important;
        margin-bottom: 0px !important;
        font-size: 12px;
        margin-inline-end: 7px;
        margin-top: 1px;
        float:inline-end;
        margin-inline-start:5px;
        position: relative;
        top: 5px;
    }
    .VuePagination__pagination-item {
        font-size: 14px;
        width: 27px;
    }
    .VuePagination__pagination-item-prev-chunk {
        display:none;
    }
    .VuePagination__pagination-item-next-chunk{
        display:none;
    }

    .VuePagination__pagination-item-prev-page{
        width:60px !important;
    }

    .VuePagination__pagination-item-next-page{
        width:60px !important;
    }

    .VuePagination__pagination-item-next-page a:before{
        width:60px;
        content: "next ";
    }

    .VuePagination__pagination-item-prev-page a:after{
        width:60px;
        content: " prev";
    }
    .v-list{
        padding:0px !important;
    }
    .v-list-item{
        text-align: start;
        border: $border-color !important;
        min-height: 37px !important;
        padding: 0 10px !important;
        font-size: 12px !important;
        .v-list-item__title{
                font-size: 14px !important;
                color:$text-color !important;
        }
        }
    .v-menu__content{
        width:150px !important;
    }
    .page-item.disabled .page-link {
        color: #6c757d;
        pointer-events: none;
        cursor: auto; 
    }

    .page-item.disabled .page-link {
        color: #6c757d;
        pointer-events: none;
        cursor: auto;
    }
    .page-link {
        border: 1px solid #4a4a4a!important;
        color: #eee;
        padding: 5px!important;
    }
    .page-link:hover {
        z-index: 2;
        color: #fff !important;
        text-decoration: none;
        background-color: #22272b!important;
    }

    .page-link.active:hover {
        color:   $active-blue !important;
    }

  }  
</style>